<template>
  <div class="sort-field">
    <div style="display: inline-block;" class="pr-2">
      <span
        class="nc-icon nc-stre-up sort-icon d-block"
        :class="getClassForSort(sortType.ASK)"
        @click="$emit('changeSort', sortField, sortType.ASK)"
      ></span>
      <span
        class="nc-icon nc-stre-down sort-icon d-block"
        :class="getClassForSort(sortType.DESC)"
        @click="$emit('changeSort', sortField, sortType.DESC)"
      ></span>
    </div>
    <span
      class="pt-1 sort-icon"
      @click="$emit('toggleSort', sortField)"
    >{{columnTitle}}</span>
  </div>
</template>

<script lang="ts">

import {defineComponent, PropType} from "vue";
import {sortType} from "@/services/consts";

export default defineComponent({
  setup() {
    return {
      sortType
    }
  },
  data() {
    return {
      selectedDeviceType: null as number | null,
    }
  },
  props: {
    columnTitle: {
      type: String as PropType<string>,
      required: true
    },
    sortField: {
      type: String as PropType<string>,
      required: true
    },
    currentSortType: {
      type: String as PropType<string|undefined>,
      required: true
    },
    currentSortField: {
      type: String as PropType<string|undefined>,
      required: true,
      default: 'def'
    },
  },
  mounted() {
    //
  },
  name: "TableSort",
  computed: {
  },
  emits: ['toggleSort', 'changeSort'],
  watch: {},
  methods: {
    getClassForSort(needSortType: sortType): object {
      if ( this.currentSortField == this.sortField && this.currentSortType == needSortType ){
        return {'font-weight-bold': true}
      }
      return {}
    },
  },
  components: {},
})
</script>

<style scoped>
  .sort-field {
    display: flex;
    align-items: center;
  }
  
  .sort-field .material-symbols-outlined {
    cursor: pointer;
    margin-left: 2px;
    font-size: 18px;
  }
  
  .sort-icon:hover {
    cursor: pointer;
    opacity: 0.5;
  }
</style>